export const masteruri=GetMasterUri();

/**
 * Die Adresse der Hub-API.
 *
 * Die API liegt immer auf derselben Herkunft wie die Seite: In der Produktion
 * bedient nginx beides - die Oberflaeche und /api -, im Entwicklungsbetrieb
 * uebernimmt der Proxy von Vite dieselbe Aufgabe (siehe vite.config.ts).
 *
 * Vorher stand hier fest zusammengesetzt
 *
 *     return `https://${window.location.hostname}/api`;
 *
 * also ohne Port. In der Produktion stimmt das zufaellig, weil nginx auf 443
 * liegt; im Entwicklungsbetrieb zeigte es an Vite vorbei.
 */
export function GetMasterUri(){
    return `${window.location.origin}/api`;
}
